
    /**
     * @description
     *  Modelo de una promoción.
     *
     * @see gigot-backend/Models/Promotions/Base/Promotion.cs
     */

export class Promotion {

    // TODO: Completar propiedades, método 'empty' y método 'from'.

    /**
     * @description
     *	Construye una promoción con una semántica vacía. Nótese que no es lo
     *  mismo que construir una promoción con valores por defecto. Las reglas
     *  generales de construcción son:
     *
     *      - Campos 'array' se definen como [].
     *      - Campos 'boolean' se definen como 'false'.
     *      - Campos 'Date' se definen como 'undefined'.
     *      - Campos 'enum' se definen como 'undefined'.
     *      - Campos 'number' se definen como 'undefined'.
     *      - Campos 'string' se definen como '' (cadena vacía).
     *      - Campos 'object' se definen llamando a su propio método #empty().
     *      - Campos de la superclase se definen al igual que campos 'object'.
     *      - Campos genéricos se definen como 'undefined'.
	 *		- Campos recursivos se definen como 'undefined'.
     *
     * @returns
     *	Una promoción vacía.
     */
    public static empty(): Promotion {
        const promotion: Promotion = new Promotion();
        return promotion;
    }

	/**
     * @description
     *  Método de reificación de un modelo compatible anémico. Esto permite
     *  ejecutar lógica de negocios sobre el modelo generado, siendo que el
     *  valor de sus propiedades se mantiene.
     *
     * @param anemicPromotion
     *  El modelo anémico a reificar.
     *
     * @returns
     *  Devuelve un modelo de esta clase, cuyas propiedades fueron copiadas en
     *  profundidad desde el modelo anémico.
     */
	public static from(anemicPromotion: Promotion): Promotion {
		if (!anemicPromotion) return undefined;
        const promotion: Promotion = Promotion.empty();
		return promotion;
	}
}
